import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M49.955 22.061c-1.484 0-2.913.59-3.916 1.598L19.17 50.198c-.364.363-.105.99.406.99h3.338v24.656c0 1.155 1.01 2.096 2.25 2.096h49.412c1.238 0 2.242-.941 2.242-2.096V51.188h3.604a.58.58 0 0 0 .406-.992l-26.945-26.52a5.3 5.3 0 0 0-1.787-1.192 5.7 5.7 0 0 0-2.14-.423zM46.41 52.356h8.035c5.406 0 10.005 3.276 10.844 7.725l.26 1.39v1.184c0 4.776-4.649 8.652-10.389 8.652h-9.629c-5.735 0-10.385-3.876-10.385-8.652V61.47l.582-2.068c1.168-4.13 5.589-7.047 10.682-7.047z" })
});
export default SvgHome;
